<template>
  <div class="purchased-container app-container">
    <h2 class="page-title"><i class="el-icon-shopping-bag-1"></i> 已购商品</h2>
    
    <el-row :gutter="20" v-loading="listLoading">
      <el-col 
        v-for="item in list" 
        :key="item.Id"
        :xs="24" 
        :sm="12" 
        :md="8" 
        :lg="6"
        class="product-card"
      >
        <el-card shadow="hover">
          <div slot="header" class="card-header">
            <h3 class="product-name">{{ item.ProductName }}</h3>
            <el-tag 
              :type="item.IsActive ? 'success' : 'danger'" 
              effect="plain"
              size="mini"
            >
              {{ item.IsActive ? '已启用' : '已禁用' }}
            </el-tag>
          </div>
          
          <div class="card-content">
            <div class="usage-info">
              <el-tag 
                :type="getUsageType(item.RemainingUsage)"
                effect="dark"
                class="usage-tag"
              >
                <span class="count-text">剩余次数</span>
                <span class="count-number">{{ item.RemainingUsage }}</span>
              </el-tag>
            </div>
            
            <div class="meta-info">
              <el-button 
                :type="item.IsActive ? 'danger' : 'success'"
                size="small"
                :loading="item.statusLoading"
                @click="handleToggleStatus(item)"
                class="status-btn"
              >
                {{ item.IsActive ? '禁用' : '启用' }}
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getPurchasedProducts, toggleProductStatus } from '@/api/api'

export default {
  data() {
    return {
      list: [],
      listLoading: false
    }
  },
  methods: {
    // 获取已购商品
    handleQuery() {
      this.listLoading = true
      getPurchasedProducts().then(res => {
        console.log(res)
        if (!res.data.success) {
          if (res.data.msg === '用户未绑定游戏角色') {
            this.$message.error('请先绑定游戏角色')
            this.$router.push('/usercenter/profile') // 假设绑定页面路由为/user/bind
            return
          }
          this.$message.error(res.data.msg || '获取数据失败')
          return
        }
        this.list = res.data.response.map(item => ({
          ...item,
          statusLoading: false,
          IsActive: item.IsActive
        }))
      }).finally(() => {
        this.listLoading = false
      })
    },

    // 切换状态
    async handleToggleStatus(item) {
      item.statusLoading = true
      try {
        const res = await toggleProductStatus(item.ProductId)
        if (res.data.success) {
          item.IsActive = res.data.response
          this.$message.success(res.data.msg)
        }
      } catch (error) {
        this.$message.error('状态切换失败')
      } finally {
        item.statusLoading = false
      }
    },

    // 根据剩余次数显示不同颜色
    getUsageType(count) {
      if(count >= 40) return 'success'
      if(count >= 10) return 'warning'
      return 'danger'
    },

    // 格式化时间
    formatTime(timeStr) {
      return timeStr ? timeStr.substr(0, 16).replace(' ', '<br>') : '-'
    }
  },
  mounted() {
    this.handleQuery()
  }
}
</script>

<style scoped>
.page-title {
  color: #666;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.purchased-container {
  padding: 20px;
}

.product-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-name {
  margin: 0;
  font-size: 16px;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 调整卡片内容布局 */
.card-content {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.usage-info {
  text-align: center;
}

.usage-tag {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;  /* 增加内边距 */
  min-width: 100px;    /* 增加最小宽度 */
  border-radius: 25px; /* 调整圆角 */
  line-height: 1;
  box-sizing: border-box; /* 确保尺寸计算正确 */
}

.count-text {
  font-size: 12px;
  margin-bottom: 3px;
}

.count-number {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  margin-top: 2px;     /* 精确控制间距 */
}

.meta-info {
  margin-top: 15px;
  text-align: center;
}

.status-btn {
  min-width: 60px;
}
</style>